import type { FieldComponentProps } from "@w3rone/json-schema-form"
import { StringField } from "./StringField"
import InputAdornment from "@mui/material/InputAdornment"

export const MoneyField = (props: FieldComponentProps) => {
  return (
    <StringField
      {...props}
      endAdornment={<InputAdornment position="end">€</InputAdornment>}
    />
  )
}
